import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './AuthPage.css';

const host = process.env.REACT_APP_API_HOST; // API 地址

function RegisterPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState(''); // 新增姓名字段
    const [email, setEmail] = useState(''); // 新增电子邮件字段
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState(''); // 用于显示成功提示
    const navigate = useNavigate();

    const validateInputs = () => {
        // 检查用户名
        if (!username || username.length < 3 || username.length > 20) {
            setError('用户名必须在 3 到 20 个字符之间。');
            return false;
        }

        // 检查密码
        if (!password || password.length < 6) {
            setError('密码长度必须至少为 6 个字符。');
            return false;
        }

        // 检查姓名
        if (!name || name.length < 2 || name.length > 50) {
            setError('姓名必须在 2 到 50 个字符之间。');
            return false;
        }

        // 检查电子邮件格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setError('请输入有效的电子邮件地址。');
            return false;
        }

        // 清除错误信息
        setError('');
        return true;
    };

    const handleRegister = (e) => {
        e.preventDefault();

        // 验证输入
        if (!validateInputs()) {
            return;
        }

        axios
            .post(`${host}/api/auth/register`, {
                username,
                password,
                name,
                email
            })
            .then(() => {
                setSuccessMessage('注册成功，请等待管理员审核后再登录。');
                setTimeout(() => navigate('/login'), 3000); // 3秒后跳转到登录页面
            })
            .catch((err) => {
                if (err.response && err.response.data.error) {
                    setError(err.response.data.error);
                } else {
                    setError('注册失败，请稍后重试。');
                }
            });
    };

    return (
        <div className="auth-container">
            <h1>铠大师智能体对话管理系统</h1>
            <div className="auth-box">
                <h1>Register</h1>
                <form onSubmit={handleRegister}>
                    <div className="form-group">
                        <label>账号:</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>密码:</label>
                        <div className="password-input">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                className={`password-toggle ${showPassword ? 'show' : ''}`}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? '🔓' : '🔒'}
                            </span>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>姓名:</label> {/* 新增姓名输入框 */}
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Email:</label> {/* 新增电子邮件输入框 */}
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    {successMessage && <p className="success-message">{successMessage}</p>}
                    <div className="form-actions">
                        <button type="submit">Register</button>
                        <p>
                            已有账号？ <Link to="/login">请登录</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default RegisterPage;